import _slicedToArray from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js";
import "core-js/modules/es6.regexp.split.js";
/**
 * Split a panel.
 *
 * @param commit
 * @param payload
 */
export function splitPanel(_ref, payload) {
  var commit = _ref.commit;
  var open;
  switch (payload) {
    case 'leftA':
      open = 'leftB';
      break;
    case 'leftB':
      open = 'leftA';
      break;
    case 'rightA':
      open = 'rightB';
      break;
    default:
      open = 'rightA';
  }
  commit('SPLIT', open);
}
export function removePanel(_ref2, payload) {
  var commit = _ref2.commit;
  commit('REMOVE', payload);
}

/**
 * Set a component to a panel.
 *
 * @param commit
 * @param payload
 */
export function setPanel(_ref3, payload) {
  var commit = _ref3.commit;
  commit('SET_PANEL', payload);
}

/***
 * Reset panel data based on side.
 *
 * @param commit
 * @param side
 */
export function resetPanelData(_ref4, side) {
  var commit = _ref4.commit;
  commit('RESET_PANEL_DATA', side);
}

// FLOAT PANEL

export function closeFloatPanel(_ref5) {
  var commit = _ref5.commit;
  commit('SET_OPEN_FLOAT_PANEL', false);
}
export function openFloatPanel(_ref6, data) {
  var commit = _ref6.commit;
  var _data$split = data.split('/'),
    _data$split2 = _slicedToArray(_data$split, 2),
    panelComponent = _data$split2[0],
    moduleComponent = _data$split2[1];
  commit('SET_FLOAT_PANEL_CONTENT', {
    panelComponent: panelComponent,
    moduleComponent: moduleComponent
  });
  commit('SET_OPEN_FLOAT_PANEL', true);
}
export function floatPanelTitle(_ref7, title) {
  var commit = _ref7.commit;
  commit('SET_FLOAT_PANEL_TITLE', title);
}

/**
 * Update Queries.
 *
 * @param commit
 * @param payload
 */
export function updateQuery(_ref8, payload) {
  var commit = _ref8.commit;
  commit('UPDATE_QUERY', payload);
}
export function getQuery(_ref9, payload) {
  var commit = _ref9.commit;
  commit('GET_QUERY', payload);
}